/**
 * @param jsCookie {JSCookie}
 */
function runAppendUtmCookieFieldsToAllForms(jsCookie) {
	document.querySelectorAll("form").forEach((form) => {
		runAppendUtmCookieFieldsToForm(form, jsCookie);
	});
}